import { memo, type FC } from "react";
import type {
  ConditionCategory,
  ConditionOperator,
  SegmentCondition,
  SegmentPreview,
  SegmentRules,
} from "../CreateSegment.Constants";
import type { SegmentPromptState } from "../UseSegmentPrompt";
import type { SegmentPreviewStatus } from "../UseSegmentPreview";
import MatchingCustomersCard from "../Components/MatchingCustomersCard";
import SegmentConditionsCard from "../Components/SegmentConditionsCard";
import SegmentPromptPanel from "../Components/Prompt/SegmentPromptPanel";

interface BuildRulesStepProps {
  rules: SegmentRules;
  preview: SegmentPreview | null;
  previewStatus: SegmentPreviewStatus;
  summary: string;
  showErrors: boolean;
  onReplaceCondition: (_condition: SegmentCondition) => void;
  onChangeCategory: (_id: number, _category: ConditionCategory) => void;
  onAddCondition: (_operator: ConditionOperator) => void;
  onDuplicateCondition: (_id: number) => void;
  onRemoveCondition: (_id: number) => void;
  onToggleOperator: (_index: number) => void;
  prompt: SegmentPromptState;
}

const BuildRulesStep: FC<BuildRulesStepProps> = ({
  prompt,
  rules,
  preview,
  previewStatus,
  summary,
  showErrors,
  onReplaceCondition,
  onChangeCategory,
  onAddCondition,
  onDuplicateCondition,
  onRemoveCondition,
  onToggleOperator,
}) => (
  <>
    <SegmentPromptPanel prompt={prompt} />
    <MatchingCustomersCard preview={preview} status={previewStatus} summary={summary} />
    <SegmentConditionsCard
      rules={rules}
      stepCounts={preview?.steps}
      showErrors={showErrors}
      onChange={onReplaceCondition}
      onChangeCategory={onChangeCategory}
      onAdd={onAddCondition}
      onDuplicate={onDuplicateCondition}
      onRemove={onRemoveCondition}
      onToggleOperator={onToggleOperator}
    />
  </>
);

export default memo(BuildRulesStep);
